import { render, staticRenderFns } from "./NotificationsDigest.vue?vue&type=template&id=0800456d&"
import script from "./NotificationsDigest.vue?vue&type=script&lang=ts&"
export * from "./NotificationsDigest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports